import React from 'react'
import { Grid, Box, Typography, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material'; //eslint-disable-line
import { useTranslation } from 'react-i18next';
import { maskCep, formatDocument, toCurrency } from 'src/utils/formatters'; //eslint-disable-line
import dayjs from 'dayjs';
import { useRecordContext } from 'react-admin';
import { useStatus } from 'src/hooks/useStatus';


const TransactionsBoleto = ({ TransTypography, TransBox, TitleField, TransFunction, TransSpan, TableCellRight  }) => {
  const { t } = useTranslation();

  const getStatus = useStatus();


const CartData = () => {
    const record = useRecordContext();
    return(
        <div style={{width: '100%', textAlign: 'center', margin: '15px 0px 15px 0px'}}>
            <h2 align="center">Dados do Carrinho</h2>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>ID do Vendedor</TableCell>
                        <TableCellRight>
                            Nome do Vendedor
                        </TableCellRight>
                        <TableCellRight>
                            Valor do Item
                        </TableCellRight>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {record.cart.map((cart,idx) => (
                        <TableRow key={idx}>
                            <TableCell>
                                {cart.sellerId}
                            </TableCell>
                            <TableCellRight>{cart.sellerName}</TableCellRight>
                            <TableCellRight>{toCurrency(cart.price)}</TableCellRight>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    )
}

  return (
      <Grid container width={{ xs: '100%', xl: '100%' }} spacing={1}>
          <Grid item xs={38} md={32}>
              <TransTypography variant="h6" gutterBottom>
                  {t('Transactions.TransationData')}
              </TransTypography>
              <Box display={{ xs: 'block', sm: 'flex' }}>
                  <TransBox margin={'10px 0'} flex={1} mr={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Transactions.paymentId')}</TitleField>
                      <TransFunction render={record => record?.id ?
                          <TransSpan>{record?.id}</TransSpan>
                        : <span style={{opacity: 0}}>sem dados</span>
                      } 
                      />
                  </TransBox>
                  <TransBox margin={'10px 10px'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Transactions.created_at')}</TitleField>
                      <TransFunction render={record => record?.created_at ?
                          <TransSpan>{dayjs(record?.created_at).format('DD/MM/YYYY')}</TransSpan>
                        : <span style={{opacity: 0}}>sem dados</span>
                      } 
                      />
                  </TransBox>
                  <TransBox margin={'10px 0'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Transactions.paymentDate')}</TitleField>
                      <TransFunction render={record => record?.payment_at ?
                          <TransSpan>{dayjs(record?.payment_at).format('DD/MM/YYYY')}</TransSpan>
                        : <span style={{opacity: 0}}>sem dados</span>
                      } 
                      />
                  </TransBox>
              </Box>

              <Box display={{ xs: 'block', sm: 'flex' }}>
                  <TransBox margin={'10px 0'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Transactions.salesChannel')}</TitleField>
                      <TransFunction render={record => record?.salesChannel ?
                          <TransSpan>{record?.salesChannel}</TransSpan>
                        : <span style={{opacity: 0}}>sem dados</span>
                      } 
                      />
                  </TransBox>

                  <TransBox margin={'10px 0px'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Transactions.status')}</TitleField>
                      <TransFunction render={record => <TransSpan>{getStatus(record.status)}</TransSpan>} />
                  </TransBox>

                  <TransBox margin={'10px 0'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Transactions.transactionType')}</TitleField>
                      <TransFunction render={record => record?.transactionType ?
                          <TransSpan>{record?.transactionType}</TransSpan>
                        : <span style={{opacity: 0}}>sem dados</span>
                      } 
                      />
                  </TransBox>
              </Box>
          </Grid>
                      
          <CartData />

          <Grid item xs={38} md={32}>
              <TransTypography variant="h6" gutterBottom>
                  {t('Boleto.titleBoleto')}
              </TransTypography>
              <Box display={{ xs: 'block', sm: 'flex' }}>
                  <TransBox margin={'10px 0px'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Boleto.nome')}</TitleField>
                      <TransFunction render={record => <TransSpan>{record.buyerData.name}</TransSpan>} />
                  </TransBox>
                  <TransBox margin={'10px 0'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Boleto.cpf')}</TitleField>
                      <TransFunction render={record => <TransSpan>{formatDocument(record.buyerData.Identity)}</TransSpan>} />
                  </TransBox>
              </Box>
              <Box display={{ xs: 'block', sm: 'flex' }}>
                  <TransBox margin={'10px 0'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Boleto.logradouro')}</TitleField>
                      <TransFunction render={record => <TransSpan>{record.buyerData.address.logradouro}</TransSpan>} />
                  </TransBox>

                  <TransBox margin={'10px 0px'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Boleto.city')}</TitleField>
                      <TransFunction render={record => <TransSpan>{record.buyerData.address.city}</TransSpan>} />
                  </TransBox>

                  <TransBox margin={'10px 0px'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Boleto.district')}</TitleField>
                      <TransFunction render={record => <TransSpan>{record.buyerData.address.district}</TransSpan>} />
                  </TransBox>
              </Box>
              <Box display={{ xs: 'block', sm: 'flex' }}>
                  <TransBox margin={'10px 0'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Boleto.cep')}</TitleField>
                      <TransFunction render={record => <TransSpan>{maskCep(record.buyerData.address.cep)}</TransSpan>} />
                  </TransBox>

                  <TransBox margin={'10px 0px'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Boleto.number')}</TitleField>
                      <TransFunction render={record => <TransSpan>{record.buyerData.address.number}</TransSpan>} />
                  </TransBox>

                  <TransBox margin={'10px 0px'} flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                      <TitleField>{t('Boleto.complement')}</TitleField>
                      <TransFunction render={record => record?.buyerData.address.complement ?
                          <TransSpan>{record.buyerData.address.complement}</TransSpan>
                        : <span style={{opacity: 0}}>sem dados</span>
                        } />
                  </TransBox>
              </Box>
          </Grid>
      </Grid>
  )
}

export default TransactionsBoleto